var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpRight01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.49994H19V5.49994H18V6.49994ZM17.2929 5.79284L5.29289 17.7929L6.70711 19.2071L18.7071 7.20704L17.2929 5.79284ZM11 7.49994H18V5.49994H11V7.49994ZM17 6.49994V13.4999H19V6.49994H17Z",
    fill: "#25282B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight01);
export default __webpack_public_path__ + "static/media/arrow-up-right-01.11039f3eac38ef97a9dfaa2299881ed6.svg";
export { ForwardRef as ReactComponent };